"use client";

import Link from "next/link";
import { Clock3 } from "lucide-react";
import type { ToolRegistryItem } from "@/types/tools";
import { useRecentTools } from "./local-tool-storage";

type RecentToolsProps = {
  tools: ToolRegistryItem[];
};

export function RecentTools({ tools }: RecentToolsProps) {
  const recentTools = useRecentTools(tools, 5);

  return (
    <div>
      <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-zinc-600">
        <Clock3 className="h-3.5 w-3.5" />
        Recent
      </div>
      {recentTools.length ? (
        <div className="space-y-1">
          {recentTools.map((tool) => (
            <Link
              key={tool.id}
              href={tool.route}
              prefetch={false}
              className="block truncate rounded-md px-3 py-2 text-sm text-zinc-600 hover:bg-zinc-100 hover:text-zinc-950"
            >
              {tool.name}
            </Link>
          ))}
        </div>
      ) : (
        <p className="rounded-md border border-dashed border-zinc-200 px-3 py-3 text-xs leading-5 text-zinc-500">
          Tools you open will appear here.
        </p>
      )}
    </div>
  );
}
